import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import getRelayEnvironment from '../../../relayClientEnvironment';
import serverVars from 'server-vars';

function getWrapperElement() {
    const wrapperElement = document.createElement('div');
    wrapperElement.classList.add('tradePromoContainer');
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}

function importPromoModal() {
    return import(
        /* webpackChunkName: "TradePromoModalChunk" */
        '../../../TradePromoModal/TradePromoModal'
    ).then(mod => mod.TradePromoModal);
}

export const tradePromoAction = ({ customActionType }) => dispatch => {
    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('messages');
    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[localeDataKey]);
    }
    importPromoModal().then(TradePromoModal => {
        const modal = (
            <IntlProvider locale={localeDataKey} messages={messages}>
                <TradePromoModal openOnRender environment={getRelayEnvironment()} />
            </IntlProvider>
        );
        ReactDOM.render(modal, getWrapperElement());
    });

    return dispatch({ type: customActionType.actionType });
};
